import React from "react";
import { useNavigate } from "react-router-dom";
import { createBlogTag } from "adminApi/BlogApi/BlogTag";
import { BlogTagRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import fields from "../../json/BlogTagFields.json";
import BlogTagForm from "./Components/BlogTagForm";

const AddBlogTag = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, BlogTagRules);

    const { loading, handleSubmit } = useFormSubmit(
        async (formValues) => await createBlogTag({ data: formValues }),
        (vals) => {
            const err = validateForm(vals, BlogTagRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Tag created successfully"
    );

    return (
        <>
            {loading && <Spinner isSpinner={true} />}
            <BlogTagForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loading}
                title="Add Blog Tag"
                submitLabel="Create Tag"
            />
        </>
    );
};

export default AddBlogTag;
